import { render } from "./UnfoldLessHorizontal.vue.js?vue&type=template&id=53982bc6!=!../vue-loader/dist/index.js??ruleSet[0]!./UnfoldLessHorizontal.vue?vue&type=template&id=53982bc6"
import script from "./UnfoldLessHorizontal.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./UnfoldLessHorizontal.vue?vue&type=script&lang=js"
export * from "./UnfoldLessHorizontal.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./UnfoldLessHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__